import { call, put, takeEvery, select, delay, all } from 'redux-saga/effects';
import * as ordersActions from '../actions/orders';
import { getAllOrdersRequest, getFilterOrdersRequest } from '../../api/orders';
import history from '../../../../../common/history';
import { errorProcessing } from '../../../../Employees/api/errorProcessing';
import { setViewLogRequest } from '../../../../../common/api/viewLog/setViewLogRequest';
import { deleteViewLogRequest } from '../../../../../common/api/viewLog/deletViewLogRequest';

const getAllOrders = state => {
  return (
    state.Executorship &&
    state.Executorship.Orders &&
    state.Executorship.Orders.orders.allOrders
  );
};

const getActiveProfileId = state => {
  return (
    state.Authorization &&
    state.Authorization.activeProfile &&
    state.Authorization.activeProfile.profileId
  );
};

function* getAllOrdersSaga(payload) {
  // const pagination = payload.payload && payload.payload.pagination || null;
  const sort = payload.payload && payload.payload.sort || {};

  let activeProfileId = yield select(getActiveProfileId);
  if (activeProfileId) {
    try {
      const response = yield call(getAllOrdersRequest, activeProfileId, sort);

      let orderTypes = {};
      let ordersStat = {};
      let drivers = [];
      let watchedStat = {
        watched: 0,
        unwatched: 0,
      };
      response.forEach(item => {
        watchedStat[item.watched ? 'watched' : 'unwatched']++;
        if (item.state.statusKeyGroup) {
          const { statusKeyGroup } = item.state;
          if (!orderTypes.hasOwnProperty(statusKeyGroup)) {
            orderTypes[statusKeyGroup] = {
              key: statusKeyGroup,
              status: item.state.status,
            };
          }
          ordersStat.hasOwnProperty(statusKeyGroup)
            ? ordersStat[statusKeyGroup]++
            : (ordersStat[statusKeyGroup] = 1);
        }
        // собираем всех водителей и исключаем дубликаты
        if (item.driver && item.driver.length > 0) {
          item.driver.forEach(driver => {
            if (!drivers.some(item => item.id === driver.id)) {
              drivers.push(driver);
            }
          });
        }
      });
      yield put(
        ordersActions.getAllOrdersSuccess({
          orderTypes: Object.keys(orderTypes).map(key => orderTypes[key]),
          orders: response,
          ordersStat,
          drivers,
          watchedStat,
        })
      );
    } catch (err) {
      yield put(ordersActions.getAllOrdersError(errorProcessing(err)));
    }
  } else {
    yield delay(500);
    activeProfileId = yield select(getActiveProfileId);
    activeProfileId
      ? yield put(ordersActions.getAllOrders())
      : history.push('/authorization/profiles');
  }
}

// todo вынести повторяющий код из getFilterOrdersSaga и getAllOrdersSaga в отдельные функции
function* getFilterOrdersSaga(action) {
  let activeProfileId = yield select(getActiveProfileId);
  if (activeProfileId) {
    try {
      const response = yield call(
        getFilterOrdersRequest,
        activeProfileId,
        action.payload
      );
      let drivers = [];
      let ordersStat = {};
      response.forEach(item => {
        if (item.state.statusKeyGroup) {
          const { statusKeyGroup } = item.state;
          ordersStat.hasOwnProperty(statusKeyGroup)
            ? ordersStat[statusKeyGroup]++
            : (ordersStat[statusKeyGroup] = 1);
        }
        // собираем всех водителей и исключаем дубликаты
        if (item.driver && item.driver.length > 0) {
          item.driver.forEach(driver => {
            if (!drivers.some(item => item.id === driver.id)) {
              drivers.push(driver);
            }
          });
        }
      });
      yield put(
        ordersActions.getFilterOrdersSuccess({
          orders: response,
          ordersStat,
          drivers,
        })
      );
    } catch (err) {
      yield put(ordersActions.getFilterOrdersError(errorProcessing(err)));
    }
  } else {
    yield delay(500);
    activeProfileId = yield select(getActiveProfileId);
    activeProfileId
      ? yield put(ordersActions.getFilterOrders(action.payload))
      : history.push('/authorization/profiles');
  }
}

function* watchOrderSaga(action) {
  let activeProfileId = yield select(getActiveProfileId);
  if (activeProfileId) {
    try {
      const { payload } = action;
      const response =
        payload &&
        (yield all(
          payload.map(item =>
            call(setViewLogRequest, activeProfileId, item, 'order')
          )
        ));
      let allOrders = yield select(getAllOrders);
      response.map(
        (res, idx) =>
          res.data &&
          res.data.result &&
          allOrders.map(
            order => order.id === payload[idx] && (order.watched = true)
          )
      );
      let watchedStat = {};
      let watched = 0;
      let unwatched = 0;
      allOrders.forEach(item => {
        if (item.watched) {
          watched++;
        } else {
          unwatched++;
        }
      });
      watchedStat.watched = watched;
      watchedStat.unwatched = unwatched;
      yield put(
        ordersActions.watchOrderSuccess({
          orders: allOrders,
          watchedStat,
        })
      );
    } catch (e) {
      yield put(ordersActions.watchOrderFailure(errorProcessing(e)));
    }
  }
}

function* unwatchOrderSaga(action) {
  let activeProfileId = yield select(getActiveProfileId);
  if (activeProfileId) {
    try {
      const { payload } = action;
      const response =
        payload &&
        (yield all(
          payload.map(item =>
            call(deleteViewLogRequest, activeProfileId, item, 'order')
          )
        ));
      let allOrders = yield select(getAllOrders);
      response.map(
        (res, idx) =>
          res.data &&
          res.data.result &&
          allOrders.map(
            order => order.id === payload[idx] && (order.watched = false)
          )
      );
      let watchedStat = {};
      let watched = 0;
      let unwatched = 0;
      allOrders.forEach(item => {
        if (item.watched) {
          watched++;
        } else {
          unwatched++;
        }
      });
      watchedStat.watched = watched;
      watchedStat.unwatched = unwatched;
      yield put(
        ordersActions.unwatchOrderSuccess({
          orders: allOrders,
          watchedStat,
        })
      );
    } catch (e) {
      yield put(ordersActions.unwatchOrderFailure(errorProcessing(e)));
    }
  }
}

export function* ordersConfigWatcher() {
  yield takeEvery(ordersActions.getAllOrders.toString(), getAllOrdersSaga);
  yield takeEvery(
    ordersActions.getFilterOrders.toString(),
    getFilterOrdersSaga
  );
  yield takeEvery(ordersActions.watchOrder.toString(), watchOrderSaga);
  yield takeEvery(ordersActions.unwatchOrder.toString(), unwatchOrderSaga);
}
